export default __webpack_public_path__ + "static/surface-68d1090702a32fa4f70f8a1d625cf495.png";